import { FC } from 'react';
import { useIntl } from 'react-intl';
import { ValuesType } from 'utility-types';
import {
  createBemBlockBuilder,
  SearchMultiselectDropdown,
} from '@ebsco-ui/ebsco-ui';

import { InstitutionItem } from '@app/components';
import { sharedMessages } from '@app/translations';
import { SetState } from '@app/constants';

import './AuthMethodSwitch.scss';

export type MultiselectProps = Omit<
  Parameters<typeof SearchMultiselectDropdown>[0],
  'children'
>;

export type MultiselectDropdownItem = ValuesType<MultiselectProps['options']>;

interface AuthMethodSwitchProps {
  options: MultiselectDropdownItem[];
  selectedItem: MultiselectDropdownItem;
  setCurrentMethod: SetState<InstitutionItem>;
}

const cnBem = createBemBlockBuilder(['authMethodSwitch']);
const INSTITUTION_LENGTH_TO_DISPLAY_SEARCH = 10;

export const AuthMethodSwitch: FC<AuthMethodSwitchProps> = ({
  options,
  selectedItem,
  setCurrentMethod,
}) => {
  const { $t } = useIntl();

  return (
    <SearchMultiselectDropdown
      options={options}
      initialSelectedOptions={[selectedItem]}
      isMultiSelect={false}
      isSearchable={options.length >= INSTITUTION_LENGTH_TO_DISPLAY_SEARCH}
      showSearchButton
      className={cnBem()}
      messages={{
        inputBoxPlaceholder: $t({
          id: 'login.findYourInstitution',
          defaultMessage: 'Find your institution',
        }),
        toggleBtnText: $t({
          id: 'login.openInstitutionsList',
          defaultMessage: 'Open institutions list',
        }),
        clearBtnAriaText: $t(sharedMessages.clear),
        searchBtnAriaText: $t(sharedMessages.search),
        comboboxAriaText: $t(sharedMessages.selectOptions),
        AllText: '',
        nItemSelectedText: '',
        loadingText: '',
        selectAllText: '',
        chipsDltBtnAriaText: '',
        clearAllBtnText: '',
      }}
      handleSelectChange={options =>
        setCurrentMethod(options[0] as InstitutionItem)
      }
    >
      <SearchMultiselectDropdown.Label>
        {$t({
          id: 'login.letsFindYourInstitution',
          defaultMessage: "Let's find your institution",
        })}
      </SearchMultiselectDropdown.Label>
      <SearchMultiselectDropdown.Toggle />
      <SearchMultiselectDropdown.Menu>
        <SearchMultiselectDropdown.Item />
      </SearchMultiselectDropdown.Menu>
    </SearchMultiselectDropdown>
  );
};
